import { makeAutoObservable } from "mobx";
import { Availability } from "./Availability";
import { Email } from "./Email";
export class NewsletterEmailModel {
    constructor(initialValue) {
        this.value = "";
        this.value = initialValue;
        makeAutoObservable(this);
    }
    get email() {
        return Email.create(this.value);
    }
    get availability() {
        return Availability.boolean({
            InvalidEmail: !this.email.isValid,
        });
    }
}
